"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.planListForAdminOutputDtoSchema = exports.planListForAdminInputDtoSchema = void 0;
const z = __importStar(require("zod"));
const cadstrom_shared_1 = require("@cadstrom/cadstrom-shared");
const result_dto_js_1 = require("../utils/result-dto.js");
exports.planListForAdminInputDtoSchema = z.object({
    cursor: z.string().optional(),
    limit: z.number().int().min(1).max(200).optional(),
    columnFilters: cadstrom_shared_1.QueryBuilder.createColumnFilterZodSchema(cadstrom_shared_1.Wizard.adminPlanFilterSchema).optional(),
    columnFilterLogicOperator: cadstrom_shared_1.QueryBuilder.logicOperatorSchema.optional(),
    sort: cadstrom_shared_1.QueryBuilder.createSortZodSchema(cadstrom_shared_1.Wizard.adminPlanFilterSchema).optional(),
    buildId: z.string().optional(),
});
const planStatusCountsSchema = z.object({
    total: z.number(),
    pending: z.number(),
    complete: z.number(),
    failed: z.number(),
});
exports.planListForAdminOutputDtoSchema = (0, result_dto_js_1.resultDtoSchema)({
    data: z.object({
        plans: cadstrom_shared_1.Wizard.adminPlanArrSchema.array(),
        nextCursor: z.string().nullable(),
        hasNextPage: z.boolean(),
        filteredTotal: z.number(),
        planStatusCounts: planStatusCountsSchema,
        planStatusCountsWithUserFilters: planStatusCountsSchema,
        fragmentCount: z.number(),
        fragmentCountWithUserFilters: z.number(),
    }),
});
//# sourceMappingURL=plan-list-for-admin.dto.js.map